import * as React from "react";
import { useState } from "react";
import { Typography, Box, Card, CardHeader, Avatar, Button } from "@mui/material";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { useTheme } from "@mui/material/styles";
import { ShippingMethodFormModal } from "../forms";
import { capitalize } from "src/common/UtilFunctions";
import ApiResources from "src/providers/ApiResources";
import { OwnAccountShippingMethodServiceEnum, OwnAccountEnum, ShippingMethodEnum } from "src/common/enum";
import { CourierEnum } from "src/common/enum/CourierEnum";

export function ShippingAndHandlingCard(props) {
  const {
    record,
    ...rest
  } = props;
  const [showShippingMethodEdit, setShowShippingMethodEdit] = useState(false);

  const theme = useTheme();

  const cardStyle = {
    padding: "10px",
    border: "1px solid #ebebeb",
    borderRadius: "8px"
  };

  const sectionStyle = {
    margin: "5px 0 5px 15px",
    alignItems: "center",
    display: "flex",
  };

  return (
    <>
    
    <ShippingMethodFormModal
      path={ApiResources.updateOrderShippingMethod(record.id, false)}
      title="Shipping Method"
      open={showShippingMethodEdit}
      setOpen={setShowShippingMethodEdit}
      method={record.shipping_method}
    />

    <Card sx={cardStyle} {...rest}>
      <CardHeader
        sx={{ padding: "12px" }}
        avatar={
          <Avatar
            sx={{
              bgcolor: theme.palette.grey["200"],
            }}
          >
            <LocalShippingIcon
              color="primary"
              sx={{fontSize: "16px"}}
            />
          </Avatar>
        }
        title={ShippingMethodEnum.find((method) => method.id === record.shipping_method?.type)?.name}
        titleTypographyProps={{ fontSize: "14px", fontWeight: "500" }}
      />
      {record.shipping_method?.additional ? (
        <>
        <Box display="flex" alignItems="center" sx={sectionStyle}>
          <Box>
            <Typography sx={{fontSize: "14px"}}>
            {`${
              record.shipping_method?.additional?.courier
                ? CourierEnum.find((method) => method.id === record.shipping_method?.additional?.courier)?.name
                : ""
            } (${OwnAccountShippingMethodServiceEnum.find((method) => method.id === record.shipping_method?.additional?.service)?.name})`}
            </Typography>
          </Box>
        </Box>
        <Box display="flex" alignItems="center" sx={sectionStyle}>
          <Box>
            <Typography sx={{fontSize: "14px", display: "inline-block"}}>
            {`${
              record.shipping_method?.additional?.account
                ? OwnAccountEnum.find((method) => method.id === record.shipping_method?.additional?.account)?.name
                : ""
            }`}
            </Typography>
            <Typography sx={{fontSize: "14px", fontWeight: 500, display: "inline-block", paddingLeft: "5px"}}>
            {`${
                record.shipping_method?.additional
                ? `#${record.shipping_method?.additional?.account_number}`
                : ""
            }`}
            </Typography>
          </Box>
        </Box>
        </>
      ) : null}
      <Box display="flex" justifyContent="end">
        <Button
          variant="outlined"
          size="small"
          onClick={() => setShowShippingMethodEdit(true)}
        >
          Edit
        </Button>
      </Box>
    </Card>
    </>
  );
}
